import initHomeHero from './home/hero.js';

const hero = document.querySelector('.js-hero');

if (hero) {
    initHomeHero(hero);
}
